import React, {useMemo} from 'react';
import dayjs from 'dayjs';
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { getRegionCode } from '../../utils';
import BJContent from "../../assets/BJ.txt";
import GZContent from "../../assets/GZ.txt";
import SHContent from "../../assets/SH.txt";
import SZContent from "../../assets/SZ.txt";
import HandbookContent from "../../assets/handbook.txt";

dayjs.extend(isSameOrAfter);

const regionTNCTypes = {
  SZ: { tnc: SZContent, handbook: HandbookContent }, // 深圳
  BJ: { tnc: BJContent, handbook: null }, // 北京
  GZ: { tnc: GZContent, handbook: HandbookContent }, // 广州
  SH: { tnc: SHContent, handbook: HandbookContent }, // 上海
};

const TNC = props => {
  const { tnc } = props;
  const { Address } = tnc;

  const data = useMemo(() => {
    const regionCode = getRegionCode(Address);
    return regionTNCTypes[regionCode];
  }, [Address]);

  return data ? (
    <div className={"tnc page-break"}>
      <p dangerouslySetInnerHTML={{ __html: data.tnc }} />
      {data.handbook && <p dangerouslySetInnerHTML={{ __html: data.handbook }} />}
    </div>
  ) : null;
};

export default TNC;